import { differenceInDays, endOfDay, isPast, parseISO } from 'date-fns';

export function daysRemainingFromUtcDate(targetDate: string) {
  /*
   Use end of date timestamp to get accurate days remaining:
   example if there are 13 days and 5 hours remaining, we want to show 14 days remaining
   */
  let targetDateEnd = endOfDay(parseISO(targetDate));
  const today = new Date();
  return differenceInDays(targetDateEnd, today);
}

export function isDateInPast(targetDate: string) {
  let targetDateParsed = parseISO(targetDate);
  return isPast(targetDateParsed);
}
